<template>
    <div class="hr">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                &lt;!&ndash; <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item> &ndash;&gt;-->
<!--                <el-breadcrumb-item>人事管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>组织机构管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <div style="text-align: right">
                    <el-button type="primary" @click="refreshTree" size="mini">刷新</el-button>
                </div>

                <el-tree
                        :load="load"
                        ref="tree"
                        lazy
                        node-key="id"
                        :props="props"
                        :expand-on-click-node="false"
                        accordion>
                    <div class="custom-tree-node" slot-scope="{ node }">
                         <span style="flex-grow: 1;">
                            <span v-if="node.data.type==0" slot="reference"><i  :class="node.data.icon"></i>{{ node.label }}</span>
                            <span v-if="node.data.type==1" slot="reference"><i  :class="'el-icon-s-custom'"></i>{{ node.label }}</span>
                            <span v-if="node.data.type==2" slot="reference"><i  :class="'el-icon-user-solid'"></i>{{ node.label }}</span>
                            <span style="width:300px;padding-left: 20px" v-if="node.data.id != ''">
                             <el-button type="text" size="mini" v-if="node.data.nodeType == 'user'"
                                        @click="showEditPeople(node.data,node)">修改</el-button>
                             <el-button type="text" size="mini" v-if="node.data.nodeType == 'department'"
                                        @click="handleEditDep(node.data,node)">修改</el-button>
                             <el-button type="text"
                                        size="mini" v-if="node.data.nodeType == 'company'"
                                        @click="handleLevel(node)">添加子公司</el-button>
                             <el-button type="text" size="mini" v-if="node.data.pid != null"
                                        @click="handleDeleteBy(node)">移除</el-button>

                             <el-button size="mini" type="text"  v-if="node.data.nodeType == 'company'"
                                        @click="handleCreate(node.data.id,node)" >添加部门</el-button>
                            <el-button size="mini" type="text"  v-if="node.data.nodeType == 'company'"
                                       @click="handlePeople(node.data,node)">添加员工</el-button>
                           <el-button size="mini" type="text"  v-if="node.data.nodeType == 'company'"
                                      @click="managePeople(node.data)">员工管理</el-button>
                            </span>
                          </span>
                    </div>
                </el-tree>

<!--                <el-tree :data="data"  ref="companyTree"  :lazy="false" :default-expand-all="true"  :expand-on-click-node="false"  >-->
<!--                    <span  class="custom-tree-node" style="width:500px;" slot-scope="{ node}">-->
<!--                        <span style="flex-grow: 1;">-->
<!--                            <span v-if="node.data.type==0" slot="reference"><i  :class="node.data.icon"></i>{{ node.label }}</span>-->
<!--                            <span v-if="node.data.type==1" slot="reference"><i  :class="'el-icon-user-solid'"></i>{{ node.label }}</span>-->
<!--                            <span style="width:300px;padding-left: 20px">-->
<!--                             <el-button type="text" size="mini" v-if="node.data.nodeType == 'user'"-->
<!--                                        @click="showEditPeople(node.data,node)">修改</el-button>-->
<!--                             <el-button type="text" size="mini" v-if="node.data.nodeType == 'department'"-->
<!--                                        @click="handleEditDep(node.data,node)">修改</el-button>-->
<!--                             <el-button type="text"-->
<!--                                        size="mini" v-if="node.data.nodeType == 'company'"-->
<!--                                        @click="handleLevel(node)">添加子公司</el-button>-->
<!--                             <el-button type="text" size="mini" v-if="node.data.pid != null "-->
<!--                                        @click="handleDelete(node)">删除</el-button>-->

<!--                             <el-button size="mini" type="text"  v-if="node.data.nodeType == 'company'"-->
<!--                                        @click="handleCreate(node.data.id,node)" >添加部门</el-button>-->
<!--                            <el-button size="mini" type="text"  v-if="node.data.nodeType == 'company'"-->
<!--                                       @click="handlePeople(node.data,node)">添加员工</el-button>-->
<!--                           <el-button size="mini" type="text"  v-if="node.data.nodeType == 'company'"-->
<!--                                           @click="managePeople(node.data)">员工管理</el-button>-->

<!--                            </span>-->
<!--                          </span>-->
<!--                    </span>-->
<!--                </el-tree>-->
            </el-card>
        </main>
        <el-dialog title="添加员工" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false"
                   style="padding-top: 5px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px" style="margin-bottom: 0;margin-top: 0">
                <el-form-item label="公司名称" prop="name" style="margin: 5px">
                    <el-input v-model="editForm.name" placeholder="请输入公司名称"  style="width: 340px" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="部门名称" prop="departmentId" style="margin: 5px" >
                    <el-select v-model="editForm.departmentId"  placeholder="部门名称" style="width: 340px">
                        <el-option
                                v-for="item in editForm.departments"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                    <el-form-item label="员工账号" style="margin: 5px">
                        <el-input v-model="searchForm.name" placeholder="员工账号" style="width: 250px" clearable></el-input>
                        <el-button type="primary" @click="loadUser" style="margin-left: 20px">查询</el-button>
                    </el-form-item>
                <!--                <el-button size="mini"  @click="add()">添加</el-button>-->
                <el-table stripe :data="userData" v-loading="loading" style="width: 100%" :height="200"
                          @selection-change="handleSelectionChange">
                    <!--                    <el-table-column type="index" label="序号" width="50"/>-->
                    <el-table-column type="selection" width="55"/>
                    <el-table-column prop="name" label="姓名"  width="100"/>
                    <el-table-column prop="email" label="邮箱">
                    </el-table-column>
                    <el-table-column prop="mobile" label="手机">
                    </el-table-column>
                    <el-table-column prop="type" label="" width="50">
                        <template slot-scope="scope">
                            {{ scope.row.type==0?"用户": (scope.row.type==1 ? "平台" : (scope.row.type==2 ? "供应商" : "未知"))}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 0">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="add">添 加</el-button>
            </div>
        </el-dialog>

        <el-dialog title="部门信息" :visible.sync="depDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="depForm" :model="depForm" :rules="rules2" label-width="100px">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="depForm.name" placeholder="请输入名称" maxlength="28" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="depForm.remark" placeholder="请输入备注" maxlength="100" clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="depDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="层级信息" :visible.sync="levelVisible" width="540px" :close-on-click-modal="false">
            <el-form ref="levelForm" :model="levelForm" :rules="rules" label-width="100px">
                <el-form-item label="公司名称" prop="name">
                    <el-input v-model="levelForm.name"  disabled style="width: 300px" clearable></el-input>
                </el-form-item>
                <el-form-item label="下级公司" prop="lid">
                <el-select clearable v-model="levelForm.companyId" style="width: 300px"
                        filterable remote reserve-keyword placeholder="请输入公司名称"
                        :remote-method="remoteMethod" :loading="loading">
                    <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                    <el-button type="primary"  @click="showCompany" style="margin-left: 10px">添加公司</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="levelVisible = false">取 消</el-button>
                <el-button type="primary" @click="addLevel">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="员工信息" :visible.sync="infoVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="peopleForm" :model="peopleForm" :rules="rules" label-width="100px">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="peopleForm.name"  disabled style="width: 300px" clearable></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="companyId">
                    <el-select v-model="peopleForm.companyId"  placeholder="公司名称" disabled @change="selectChanged" style="width: 300px">
                        <el-option
                                v-for="item in companys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门名称" prop="departmentId">
                    <el-select v-model="peopleForm.departmentId"  placeholder="部门名称" style="width: 300px">
                        <el-option
                                v-for="item in peopleForm.departments"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="infoVisible = false">取 消</el-button>
                <el-button type="primary" @click="editPeople">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="公司信息" :visible.sync="companyVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="companyForm" :model="companyForm" :rules="rules" label-width="100px">
                <el-form-item label="公司代码" prop="code">
                    <el-input v-model="companyForm.code" placeholder="请输入公司代码" clearable></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="name">
                    <el-input v-model="companyForm.name" placeholder="请输入公司名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="邮箱域名" prop="domain" v-if="false">
                    <el-input v-model="companyForm.domain" placeholder="请输入邮箱域名" clearable></el-input>
                </el-form-item>
                <el-form-item label="营业执照号" prop="businessLicense">
                    <el-input v-model="companyForm.businessLicense" placeholder="请输入营业执照号" clearable></el-input>
                </el-form-item>
<!--                <el-form-item label="发票类型" prop="type">-->
<!--                    <el-select v-model="companyForm.type" placeholder="请选择发票类型">-->
<!--                        <el-option value="0" key="0" label="不开发票"/>-->
<!--                        <el-option value="1" key="1" label="普票"/>-->
<!--                        <el-option value="2" key="2" label="增值税发票"/>-->
<!--                        <el-option value="3" key="3" label="电子普票"/>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="公司税号" prop="companyTaxNo">-->
<!--                    <el-input v-model="companyForm.companyTaxNo" placeholder="请输入税号" clearable></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="开户银行" prop="bankName">-->
<!--                    <el-input v-model="companyForm.bankName" placeholder="请输入开户银行" clearable></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="银行账号" prop="bankAccount">-->
<!--                    <el-input v-model="companyForm.bankAccount" placeholder="请输入银行账号" clearable></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="注册电话" prop="registeredTel">-->
<!--                    <el-input v-model="companyForm.registeredTel" placeholder="请输入注册电话" clearable></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="注册地址" prop="registeredAddress">-->
<!--                    <el-input v-model="companyForm.registeredAddress" placeholder="请输入注册地址" clearable></el-input>-->
<!--                </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="companyVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveCompany">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {

        data() {
            return {
                isPlatform :false,
                currentNode: null,
                resolve :[],
                props: {
                    id: "id",
                    label: 'label',
                    children: 'children',
                    isLeaf: 'isLeaf'
                },
                companyForm: {
                    id: "",
                    code: "",
                    name: "",
                    platform:false,
                    businessLicense: "",
                    domain: "",
                    type: "0",
                    companyTaxNo: "",
                    bankName: "",
                    bankAccount: "",
                    registeredTel: "",
                    registeredAddress: "",
                    invoice:{}
                },
                companyVisible: false,
                title: "添加上级",
                companys:[],
                companyIds:[],
                selectData:[],
                userData:[],
                deps:[],
                depForm: {
                    id: "",
                    name: "",
                    companyId: "",
                    remark: ""

                },
                peopleForm: {
                    departmentId: "",
                    id: "",
                    type: "",
                    departments: [],
                    name: "",
                    companyId: ""
                },
                depDialogVisible: false,
                infoVisible: false,
                levelVisible: false,
                searchForm: {
                    name: "",
                    domain: "",
                },
                loading: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                tableData: [],
                editDialogVisible: false,
                uploadDialogVisible: false,
                fileList: [],
                editForm: {
                    departmentId: "",
                    departments: "",
                    id: "",
                    code: "",
                    name: "",
                    domain: ""
                },
                oldPeople:{},
                levelForm: {
                    companys:[],
                    pid:"",
                    departmentId: "",
                    id: "",
                    type: "",
                    departments: [],
                    name: "",
                    companyId: "",
                    lid:""
                },
                editInvoiceDialogVisible: false,
                editInvoiceForm: {
                    id: "",
                    companyId: "",
                    type: "0",
                    companyTaxNo: "",
                    bankName: "",
                    bankAccount: "",
                    registeredTel: "",
                    registeredAddress: "",
                },
                options: [],
                rules: {
                    code: [
                        { required: true, message: '请输入公司代码', trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请输入公司名称', trigger: 'blur' }
                    ],
                    domain: [
                        { required: true, message: '请输入邮箱域名', trigger: 'blur' }
                    ],
                    businessLicense: [
                        { required: true, message: '营业执照号', trigger: 'blur' }
                    ],
                    type: [
                        { required: true, message: '请选择发票类型', trigger: 'blur' }
                    ],
                    companyTaxNo: [
                        { required: true, message: '请输入公司税号', trigger: 'blur' }
                    ],
                    bankName: [
                        { required: true, message: '请输入开户银行', trigger: 'blur' }
                    ],
                    bankAccount: [
                        { required: true, message: '请输入银行账号', trigger: 'blur' }
                    ],
                    registeredTel: [
                        { required: true, message: '请输入注册电话', trigger: 'blur' }
                    ],
                    registeredAddress: [
                        { required: true, message: '请输入注册地址', trigger: 'blur' }
                    ],

                },
                rules2: {

                    name: [
                        { required: true, message: '请输入部门名称', trigger: 'blur' }
                    ]


                },
                data: [],
            }
        },
        methods: {
            onSearch() {
                let company = {
                };
                if (this.searchForm.name != "") {
                    company["name"] = this.searchForm.name;
                }
                if (this.searchForm.domain != "") {
                    company["domain"] = this.searchForm.domain;
                }
                this.loading = true;
                let _this = this
                this.$axios.post("/admin/company/level", {
                    cond: company,
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function () {
                });
            },
            handleSelectionChange(val) {
                this.selectData = val;
            },
            handleLevel(row) {

                this.currentNode = row;



                this.levelForm.pid = row.data.id;
                this.levelForm.name = row.data.label;
                this.levelForm.companyId = "";
                this.oldPeople =  {...this.levelForm};
                this.loadCompany();
                this.options = [];
                this.levelVisible = true;

            },
            getAllCompanys(data){
                let nodeIds = [data.id];
                this.getAllCNodes(data,nodeIds);
                return nodeIds;
            },
            getCompanys(node){

                //let node = this.$refs.companyTree.getNode(resp.data.id);
                let nodeIds = [node.data.id];
                this.getAllCNodes(node.data,nodeIds);
                return nodeIds;
            },
            getAllCNodes(nodeData,nodeIds){

                let children = nodeData.children;
                //let node = this.$refs.companyTree.getNode(resp.data.id);
                if(children != undefined && children.length >0){
                    for(let i=0; i<children.length; i++){
                        let item = children[i];
                        if(item.nodeType == "company"){
                            nodeIds.push(item.id);
                            if(item.children != undefined && item.children.length >0){
                                this.getAllCNodes(item,nodeIds);
                            }
                        }

                    }

                }
            },
            handleCreate(companyId,node) {
                this.currentNode = node;
                this.depForm.id = "";
                this.depForm.companyId = companyId;
                this.depForm.name = "";
                this.depForm.remark = "";
                this.depDialogVisible = true;
            },
            handleEditDep(row,node) {
                this.currentNode = node;
                this.depForm.id = row.id;
                this.depForm.name = row.label;
                this.depForm.remark = row.remark;
                this.depDialogVisible = true;
            },
            onSubmit() {
                let _this = this;
                this.$refs.depForm.validate(valid => {
                    if (valid) {
                        this.$axios.post("/admin/company/addDep", this.depForm)
                            .then(function (response) {
                                let resp = response.data;
                                if (resp.header.status == 0) {
                                    _this.$notify({
                                        title: '成功',
                                        message: '数据保存成功',
                                        type: 'success'
                                    });
                                    _this.depDialogVisible = false;

                                    if(_this.depForm.id){
                                        _this.currentNode.parent.loaded = false;
                                        _this.currentNode.parent.expand();
                                    }else{
                                        _this.currentNode.loaded = false;
                                        _this.currentNode.expand();
                                    }



                                   // _this.load(this.currentNode,this.resolve);
                                    //_this.$refs.tree.append(resp.data, _this.currentNode);
                                    _this.loadCompanyTree();
                                    _this.loadDep();
                                } else {
                                    _this.$notify.error({
                                        title: '错误',
                                        message: resp.header.msg
                                    });
                                }
                            });
                    }
                })
            },
            onPageChange(currentPage) {
                this.currentPage = currentPage;
                this.onSearch();
            },
            handleEdit(row) {
                this.levelForm.id = row.levelId;
                this.levelForm.pid = row.pid;
                this.levelForm.name = row.name;
                this.levelForm.companyId = row.id;
                this.oldPeople =  {...this.levelForm};
                this.levelForm.companys = this.companys.filter(it => it.id != row.id);
                this.infoVisible = true;

            },
            handlePeople(row,node) {//current
                this.currentNode = node;
                this.editForm.id = row.id;
                this.editForm.name = row.label;
                this.editForm.departments = row.departments;
                this.editForm.departmentId = "";
                let d =  this.deps.filter(it => it.companyId==row.id);
                this.editForm.departments = d;
                this.searchForm.name = "";
                //this.loadUser();
                this.userData = [];
                this.editDialogVisible = true;
            },
            managePeople(row) {
                this.$router.push({name: "customerUsers", params: {from: "user", companyId: row.id,name:row.label}})

            },
            showEditPeople(row,node) {
                this.currentNode = node;
                this.peopleForm.id = row.id;
                this.peopleForm.userId = row.userId;
                this.peopleForm.name = row.label;
                this.peopleForm.type = row.type;
                this.peopleForm.companyId = row.companyId;
                if(row.companyId != null && row.companyId != ""){
                    let d =  this.deps.filter(it => it.companyId==row.companyId);
                    this.peopleForm.departments = d;
                }
                this.peopleForm.departmentId = row.departmentId;
                this.oldPeople =  {...this.peopleForm};
                this.infoVisible = true;


            },
            editPeople() {//编辑人员所属公司和部门

                if(this.peopleForm.departmentId == this.oldPeople.departmentId
                    &&this.peopleForm.companyId == this.oldPeople.companyId){
                    this.infoVisible = false;
                    return;
                }
                let users = [{
                    userId:this.peopleForm.userId,
                    companyId:this.peopleForm.companyId,
                    departmentId:this.peopleForm.departmentId,
                    type:this.peopleForm.type
                }];
                let _this = this;
                this.$confirm('是否修改员工信息？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {
                    _this.$axios.post("/admin/company/addUser",users)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status === 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '修改成功',
                                    type: 'success'
                                });
                                _this.infoVisible = false;
                                _this.currentNode.parent.loaded = false;
                                _this.currentNode.parent.expand();

                                let newNode =  _this.$refs.tree.getNode(users[0].departmentId);
                                newNode.loaded= false;
                                newNode.expand();


                                _this.loadCompanyTree();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                })
            },

            add() {
                if(this.selectData.length == 0){
                    this.$message({
                        type: 'info',
                        message: '请选择要添加的员工',
                        duration: 1000
                    });
                    return;
                }
                let users = [];
                for(let i=0; i<this.selectData.length; i++){
                    users.push( {companyId:this.editForm.id,userId:this.selectData[i].id,
                        type:this.selectData[i].type,departmentId:this.editForm.departmentId});
                }

                let msg =  this.selectData.map(it => it.name?it.name:it.email).join(",");
                let _this = this;
                this.$confirm('是否添加员工【' + msg + '】？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {
                    _this.$axios.post("/admin/company/addUser",users)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status === 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '添加成功',
                                    type: 'success'
                                });
                                _this.editDialogVisible = false;

                                _this.currentNode.loaded = false;
                                _this.currentNode.expand();
                                //_this.$refs.tree.append(resp.data, _this.currentNode);
                                _this.loadUser();
                                _this.loadCompanyTree();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                })
            },
            addLevel() {//编辑层级

                if(this.levelForm.companyId == this.oldPeople.companyId){
                    this.levelVisible = false;
                    return;
                }
                if(this.levelForm.pid == this.levelForm.companyId){
                    this.$notify.error({
                        title: '错误',
                        message: '不能添加本公司为下级公司'
                    });
                    return;
                }

                let level = {companyId:this.levelForm.companyId,
                    pid:this.levelForm.pid};
                let _this = this;
                this.$confirm('是否确认添加下级公司？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {
                    _this.$axios.post("/admin/company/addLevel",level)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status === 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '修改成功',
                                    type: 'success'
                                });
                                _this.levelVisible = false;


                                if(_this.isPlatform){//更新根节点
                                    let node = _this.$refs.tree.getNode("");
                                    node.loaded = false;
                                    node.expand();
                                }

                                _this.currentNode.loaded = false;
                                _this.currentNode.expand();


                                //_this.load(this.currentNode,this.resolve);

                                //_this.$refs.tree.append(resp.data, _this.currentNode);
                                //_this.loadCompanyTree();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                })
            },

            loadUser(){

                let name = "";
                if (this.searchForm.name != "") {
                    name = this.searchForm.name;
                }else{
                    return;
                }

                let _this = this;
                this.loading = true;
                this.$axios.post("/admin/company/users",name
                ).then(function (response) {
                    _this.loading = false;
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.userData = resp.data;
                    }

                });

            },
            handleDelete(row) {
                this.currentNode = row;
                let param = row.data.id;

                let url = "";
                let msg = '是否删除公司层级关系？';
                if(row.data.nodeType == "company"){

                    if(row.data.children == null || row.data.children.length == 0){
                        url = "/admin/company/deleteLevelBy";
                        param =  row.data.id;
                    }else{
                        this.$notify.error({
                            title: '错误',
                            message: '有下级关系不能删除'
                        });
                        return;
                    }


                }
                if(row.data.nodeType == "department"){
                    url = "/admin/company/deleteDep";
                    msg = '是否删除【' + row.data.label + '】部门？'
                }
                if(row.data.nodeType == "user"){
                    url = "/admin/company/deleteUser";
                    msg = '是否删除用户【' + row.data.label + '】？';
                    param = {companyId:row.data.companyId,userId:row.data.userId,type:row.data.type};
                }

                let _this = this;
                this.$confirm(msg, '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '删除',
                    cancelButtonText: '取消'
                }).then(() => {

                    _this.$axios.post(url,param)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status === 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据删除成功',
                                    type: 'success'
                                });
                                //_this.$refs.tree.remove(row);

                                _this.loadCompanyTree();
                                _this.loadDep();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                })
            },
            handleDeleteBy(row) {
                this.currentNode = row;

                let param = row.data.id;

                let url = "";
                let msg = '是否移除公司层级关系？';
                if(row.data.nodeType == "company"){

                    if(row.data.children == null || row.data.children.length == 0){
                        url = "/admin/company/deleteLevelBy";
                        param =  row.data.id;
                    }else{
                        this.$notify.error({
                            title: '错误',
                            message: '有下级关系不能移除'
                        });
                        return;
                    }
                }
                if(row.data.nodeType == "department"){
                    url = "/admin/company/deleteDep";
                    msg = '是否移除【' + row.data.label + '】部门？'
                }
                if(row.data.nodeType == "user"){
                    url = "/admin/company/deleteUser";
                    msg = '是否移除用户【' + row.data.label + '】？';
                    param = {companyId:row.data.companyId,userId:row.data.userId,type:row.data.type};
                }

                let _this = this;
                this.$confirm(msg, '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '移除',
                    cancelButtonText: '取消'
                }).then(() => {

                    _this.$axios.post(url,param)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status === 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据移除成功',
                                    type: 'success'
                                });
                                //alert(JSON.stringify(_this.currentNode.parent.data));
                                if(row.data.nodeType == "company"){
                                    if(_this.isPlatform){//更新根节点
                                        let node = _this.$refs.tree.getNode("");
                                        node.loaded = false;
                                        node.expand();
                                    }
                                }

                                _this.currentNode.parent.loaded = false;
                                _this.currentNode.parent.expand();
                                _this.loadDep();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                })
            },

            loadCompany(){
                let _this = this
                this.$axios.post("/admin/company/all"
                ).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.companys = resp.data;
                    }

                });

            },
            selectChanged(companyId) {
                if(companyId != null && companyId != ""){
                    let d =  this.deps.filter(it => it.companyId == companyId);
                    this.peopleForm.departments = d;
                    this.peopleForm.departmentId = null;

                }

            },
            refreshTree(){
                let node = this.$refs.tree.getNode("");
                node.loaded = false;
                node.expand();
            },
            loadCompanyTree(){
                let _this = this;
                _this.loading = true;
                this.$axios.post("/admin/company/cTreeList",{id:""}
                ).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.data = resp.data;
                    }
                }).finally(() => {
                    _this.loading = false;
                });

            },
            loadDep(){
                let _this = this;
                this.$axios.post("/admin/company/allDep"
                ).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.deps = resp.data;
                    }
                });

            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;

                    setTimeout(() => {
                        this.loading = false;
                        this.options = this.companys.filter(item => {
                            return item.name==query;
                        });
                    }, 200);
                } else {
                    this.options = [];
                }
            },
            showCompany(){
                this.companyForm.id = "";
                this.companyForm.code = "";
                this.companyForm.name = "";
                this.companyForm.domain = this.randomString(10);
                this.companyForm.businessLicense = "";

                this.companyForm.type = "0";
                this.companyForm.companyTaxNo = "";
                this.companyForm.bankName = "";
                this.companyForm.bankAccount = "";
                this.companyForm.registeredTel = "";
                this.companyForm.registeredAddress = "";

                this.companyVisible = true;
            },
            saveCompany() {
                let _this = this;
                this.$refs.companyForm.validate(valid => {
                    if (valid) {
                        // this.companyForm.invoice =  {
                        //     type: this.companyForm.type,
                        //     companyTaxNo:this.companyForm.companyTaxNo,
                        //     bankName: this.companyForm.bankName,
                        //     bankAccount: this.companyForm.bankAccount,
                        //     registeredTel:this.companyForm.registeredTel,
                        //     registeredAddress: this.companyForm.registeredAddress
                        // }
                        this.$axios.post("/admin/company/saveAndInvoice", this.companyForm)
                            .then(function (response) {
                                let resp = response.data;
                                if (resp.header.status == 0) {
                                    _this.$notify({
                                        title: '成功',
                                        message: '数据保存成功',
                                        type: 'success'
                                    });
                                    _this.companyVisible = false;
                                    _this.loadCompany();
                                } else {
                                    _this.$notify.error({
                                        title: '错误',
                                        message: resp.header.msg
                                    });
                                }
                            });
                    }
                })
            },
            randomString(len) {
                len = len || 32;
                var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678@';
                var maxPos = $chars.length;
                var pwd = '';
                for (let i = 0; i < len; i++) {
                    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
                }
                return pwd;
            },
            load(node, resolve) {

                if(node.level === 0) {
                    this.resolve = resolve([{id: "", type: 0, nodeType:"company", label:"公司一览"}]);
                    return this.resolve;
                } else {

                    this.loading = true;
                    let _this = this;
                    this.$axios.post("/admin/company/lazyTree", {
                        id: node.data.id,nodeType:node.data.nodeType
                    }).then(function(response) {
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            node.data.children = [];
                            resp.data.forEach((item) => {
                                if(item.nodeType == "user"){
                                    item.isLeaf = true;
                                }
                                node.data.children.push(item);
                            });
                            this.resolve = resolve(node.data.children);
                            return this.resolve;



                            //resolve(resp.data);
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                        _this.loading = false;
                    }).catch(function() {
                        _this.loading = false;
                    });
                }
            },
            isPlatformUser(){
                let _this = this;

                this.$axios.post("/admin/company/isPlatform"
                ).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.isPlatform = resp.data;
                    }
                });

            },

        },
        created() {
            const that = this;
            // this.$axios.post("/admin/rights/staff/list", { type: 1 })
            //     .then(function (response) {
            //         const resp = response.data;
            //         if (resp.header.status == 0) {
            //             that.options = resp.data;
            //
            //         }
            //     }).catch(function () {
            // });
            that.loadCompany();
            //that.loadCompanyTree();
            that.loadDep();
            that.isPlatformUser();

        },
    }
</script>
<style>
    .el-tooltip__popper{
        max-width:500px !important;
    }
    .table ::v-deep .el-table--medium .el-table__cell {
        padding: 0px !important;
    }
    ::v-deep .params .cell {
        padding: 0px !important;
        border: none;
    }
    .el-dialog__body{
        padding: 15px !important;
    }
    .el-dialog__header {
        padding: 10px;
        padding-bottom: 10px;
    }

</style>
